<!-- Logic for restaurants -->
<!--<ion-content class="ItemModalSeperator" [scrollY]="false" (click)="track($event)">-->
<ion-content #content class="ItemModalSeperator" (click)="track($event)">
  <!-- this will slide away when going to the options -->
  <div class="ItemContent" [ngClass]="{ 'ItemContent-active': !gotoOptions}">
    <!--this is for the img section-->
    <div class="ItemImgContainer" [ngClass]="{'ItemImgContainer-homers': homersLayout}">
      <!-- absolute container for the gradiant -->
      <div class="GradientBackground" [ngClass]="{'GradientBackground-homers': homersLayout}">
        <div class="IconsTopContainer">
          <div class="back-circle" (click)="cancel()">
            <ion-icon size="medium" slot="start" [ios]="'chevron-back-outline'" [md]="'chevron-back-outline'"></ion-icon>
          </div>
          

          <!-- will use later -->
          <!--
          <div class="LikeContainer" (click)="onHeartClick()">
            <ion-icon size="small" slot="start" [ios]="isFavorite ? 'heart' : 'heart-outline'" [md]="isFavorite ? 'heart' : 'heart-outline'"></ion-icon>
          </div>
          -->
        </div>
      </div>

      <!-- absolute container for the item img that will overlap others -->
      @if(itemsImgSrc) {
        <div class="ImgOverlapContainer" [ngClass]="{'ImgOverlapContainer-homers': homersLayout}">
          <img class="ImgContainer" [src]="itemsImgSrc || null" (error)="itemsImgSrc = null">
        </div>
      }
    </div>



    <!-- bottom content -->
    <div class="ItemEditingContainer">

      <!--
      @if(false) {
        <div class="TagsAndRatingContainer">
          <div class="tag">
            <ion-icon style="height: 12px; width: 12px; margin-right: 3px;" size="small" slot="start" [ios]="'star'" [md]="'star'"></ion-icon>
            <p class="tagTxt">4.3</p>
          </div>
        </div>
      }
      -->
      
        
      @if(item.item.itemName) {
        <div class="TitleContainer" [ngClass]="{'TitleContainerHomers': homersLayout}">
          <div class="itemTitle" [ngClass]="{'paytoneFont': homersLayout, 'homersTitleStyleEdit': homersLayout}">
            {{ nameDisplayed(item.item) }}
          </div>
          
          @if(!homersLayout) {
            <div class="itemPrice">
              <div class="itemPrice_Wrapper">
                {{ itemPrice | currency }}
              </div>
            </div>
          } @else {
            <div class="itemPriceHomers">
              <div class="itemPrice_Wrapper_Homers paytoneFont">
                {{ itemPrice | currency }}
              </div>
            </div>
          } 
        </div>
      }


      <!-- this actuall gets the options, we want to select other items for now-->
      <!--
      @for (optionCat of item.item.itemOptionCategories; track optionCat; let isLast = $last) {
        <div class="OptionsContainer" [ngClass]="{ 'OptionsContainer_end': isLast }">
          
            <div class="OptionsContainer_title">
              {{ optionCat.name.translations[translationService.getLanguage()] }}
            </div>
            
            <div class="Options_list_container">
              @for (option of optionCat.options; track option; let oi = $index) {
                <button class="OptionSelection" [ngClass]="{ 'OptionMargin': oi > 0 }" (click)="optionSelected(optionCat, option)">
                  {{ option.option.name.translations[translationService.getLanguage()] }}
                </button>
              }
            </div>  
        </div>
      }
      -->
      

      @if(item.item.itemDescription) {
        @if(item.item.itemDescription.title && item.item.itemDescription.description) {
          <!-- may still need some adjustments -->
          <div class="DetailsContainer">
            
            <div class="DetailsContainer_title">
              <!--{{ item.item.itemDescription.title.translations[translationService.getLanguage()] }}-->
              @if(!homersLayout) {
                {{ 'About' }}
              }
              
            </div>
            
            @if(item.item.description.translations[translationService.getLanguage()]) {
              <div class="DetailsWrapper" [ngClass]="{'DetailsWrapper-homers': homersLayout, 'expanded': isExpanded}" [style.maxHeight.px]="currentHeight">
                <div #detailsContent class="Details" [ngClass]="{'DetailsHomers': homersLayout, 'poppinsNormalFont': homersLayout, 'ExpandedDetails': isExpanded}" [innerHTML]="item.item.description.translations[translationService.getLanguage()]"> </div>
                @if(!isExpanded) {

                  <span
                    class="ReadMoreInline"
                    [ngClass]="{'ReadMoreInline-homers': homersLayout}"
                    (click)="toggleReadMore()"
                  >
                    +
                  </span>
                }

                @if(isExpanded) {
                  <div class="ExpandedFooter">
                    <!--
                    <div class="Icons">
                      <ion-icon (click)="openItemContentDetails('all')" style="color: black; cursor: pointer;" size="small" slot="start" [ios]="'heart-outline'" [md]="'heart-outline'"></ion-icon>
                      <ion-icon (click)="openItemContentDetails('all')" style="color: black; cursor: pointer;" size="small" slot="start" [ios]="'share-outline'" [md]="'share-outline'"></ion-icon>
                    </div>
                    -->

                    <span class="ReadLess" (click)="toggleReadMore()" [ngClass]="{'ReadMoreInline-homers': homersLayout}">
                      -
                    </span>
                  </div>
                }
                
              </div>
            }
            
              
          </div>
        }
      }

      <div class="Icons" [ngClass]="{'IconsHomersEdit': homersLayout}">
        @if(!homersLayout) {
          <ion-icon (click)="openItemContentDetails('nutrition')" style="color: black; cursor: pointer;" size="small" slot="start" [ios]="'nutrition-outline'" [md]="'nutrition-outline'"></ion-icon>
          <ion-icon (click)="openItemContentDetails('allergen')" style="color: black; cursor: pointer;" size="small" slot="start" [ios]="'medkit-outline'" [md]="'medkit-outline'"></ion-icon>
          <ion-icon (click)="openItemContentDetails('flavor')" style="color: black; cursor: pointer;" size="small" slot="start" [ios]="'ice-cream-outline'" [md]="'ice-cream-outline'"></ion-icon>
        } @else {
          <img (click)="openItemContentDetails('nutrition')" src="assets/homers/grain.png" alt="Nutrition" style="width: 25px; height: 25px; cursor: pointer;" slot="start" />
        }
      </div>
      
      @if (item.subItems.length > 0) {
        <div class="OptionsContainer OptionsContainer_end">
            <div class="OptionsContainer_title" [ngClass]="{'OptionsContainer_title_homers': homersLayout, 'paytoneFont': homersLayout}">
              {{ 'Quantity' }}
            </div>
            
            <div class="Options_list_container">
              @for (subItem of item.subItems; track subItem; let oi = $index) {
                <button class="OptionSelection" [ngClass]="{ 'OptionMargin': oi > 0, 'OptionSelected': selectedSubItemIndex === oi, 'paytoneFont': homersLayout, 'OptionSelection-homers': homersLayout}" (click)="subItemSelected(subItem, oi)">
                  {{ nameDisplayed(subItem) }}
                </button>
              }
            </div>  
        </div>
      }
      

      @if(!homersLayout) {
        <div class="QuantityContainer">
          <!--
          <div class="MetricContainer">
            <p class="MetricTxt" style="margin-right: 5px;"> {{ 'Volume ' }} </p>
            <p class="MetricTxt_darkened"> {{ '160ml' }} </p>
          </div>
          -->

          @if(!(selectedSubItem.itemOptionCategories.length > 0)) {
            <div class="QuantitySelectionContainer">
              <button class="QuantityBtn" (click)="changeQuantity(-1)">
                {{ '-' }}
              </button>
              <div class="QuantityCounter">
                {{ selectedQuantity }}
              </div>
              <button class="QuantityBtn" (click)="changeQuantity(1)">
                {{ '+' }}
              </button>
            </div>
          }
        </div>
      }
      


      
    </div>

    <div class="AddToCartContainer" [ngClass]="[
      selectedSubItem.itemOptionCategories.length > 0 ? 'AddToCartContainer_optionAdjusted' : '',
      selectedSubItem.itemOptionCategories.length > 0 && homersLayout ? 'AddToCartContainer-homers' : ''
    ]">
      @if(!(this.selectedSubItem.itemOptionCategories.length > 0)) {
        <div class="AddToCartButton" (click)="onStartOrder()">
          <ion-icon class="ion-icon_Cart" size="small" slot="start" [ios]="'bag-outline'" [md]="'bag-outline'"></ion-icon>
          <!--<ion-icon size="small" slot="start" [ios]="'bag'" [md]="'bag'"></ion-icon>-->

          <!-- this is the cart version -->
          <!--
          <ion-icon size="small" slot="start" [ios]="'cart-outline'" [md]="'cart-outline'"></ion-icon>
          <ion-icon size="small" slot="start" [ios]="'cart'" [md]="'cart'"></ion-icon>
          -->
        </div>
      }



      <!--
      @if ((item.item.isTakeOut && store.allowPickup)) {
        <button class="cart"  (click)="onStartOrder('pickup')">{{'Order.AddCartPickup' | translate}}</button>
      }
      @if ((item.item.isDelivery && store.allowDelivery)) {
        <button class="cart"  (click)="onStartOrder('delivery')">{{'Order.AddCartDelivery' | translate}}</button>
      }
      @if ((item.item.isShipping && store.allowShipping) ) {
        <button class="cart"  (click)="onStartOrder('shipping')">{{'Order.AddCartShipping' | translate}}</button>
      }
      -->

      @if(!seeOptions) {
        @if(this.selectedSubItem.itemOptionCategories.length > 0) {
          <button class="BuyNowButton" [ngClass]="{'BuyNowButton-homers': homersLayout, 'poppinsNormalFont': homersLayout}" (click)="viewingOptions()">
            <!--{{ 'go to the options' }}-->
            {{ 'Voir les incontournables' }}
          </button>
        } @else {
          <button class="BuyNowButton" (click)="onStartOrder(true)">
            {{ 'Buy now' }}
          </button>
        }
      } @else {
        <div class="seperatorline" [ngClass]="{'seperatorline-homers': homersLayout}"></div>
      }
      
      

      
    </div>
  </div>

    
  
  @if(seeOptions) {
    <div #optionsSection class="options-section" [ngClass]="{ 'options-section-active': gotoOptions }">
      <!--i'll attach the questions and options here-->
      @if(this.selectedSubItem) {
        <div class="subItemOptions">
          @for (itemOptionsCat of this.selectedSubItem.itemOptionCategories; track $index; let oi = $index) {
            @if(optionGroupIndex >= oi) {
              <!--
              <div class="linethrough-container">
                <div class="linethrough"></div>
              </div>
              -->
              
              <div #optionGroup class="options-container" [ngClass]="{ 'options-container-last': optionGroupIndex == oi }">
                
                <div class="option-headerbar" [ngClass]="{'option-headerbar-homers': homersLayout, 'paytoneFont': homersLayout}">
                  <!--
                  <div class="back-circle-option" (click)="backOption()">
                    <ion-icon size="small" slot="start" [ios]="'chevron-back-outline'" [md]="'chevron-back-outline'"></ion-icon>
                  </div>
                  -->

                  {{ itemOptionsCat.name?.translations[this.translationService.getLanguage()] }}
                </div>
                
                <div class="horizontal-track">
                  @for(itemOption of itemOptionsCat.options; track $index; let ooi = $index) {
                    <div class="option-card-container">
                      <!--<div class="option-card" (click)="selectedOption(itemOption)">-->

                      <div class="option-img-container">                                           

                        <!-- example
                        @if(itemsImgSrc) {
                          <div class="ImgOverlapContainer">
                            <img class="ImgContainer" [src]="itemsImgSrc || null" (error)="itemsImgSrc = null">
                          </div>
                        }
                        -->

                        <img class="optionimg" [src]="getOptionsItemImage(itemOption)" (error)="hideImage($event)" alt="">
                        <!--
                          itemOption.option.imageShortName
                        -->

                      </div>
                      <div class="option-card" [class.option-card-selected]="itemOption.option.quantity > 0" [class.option-card-wave]="itemOption.isAnimating" (click)="changeOptionQuantity(itemOption, 1, itemOptionsCat); $event.stopPropagation();">
                        <!-- add the option's image (for example, the donut you want in your box of 6)-->
                        

                        <!-- add the cost of the addon if any (for simple selection, just don't show the price)-->
                        <div class="option-details">
                          <div class="option-details-layout">
                            <div class="option-description" [ngClass]="{'paytoneFont': homersLayout}" [innerHtml]="textDisplay(itemOption.option?.name, translationService.getLanguage())"></div>

                            <!--no details concerning this-->
                            <!--
                            @if(itemOption.option.price != 0 && itemOption.option.price != null) {
                              <div class="option-price">
                                {{ '+' }} <span style="margin-left: 3px;">{{ itemOption.option.price | currency }}</span> 
                              </div>
                            }
                            -->

                            <div class="option-detailed-description" [ngClass]="{'poppinsNormalFont': homersLayout}" [innerHtml]="textDisplay(itemOption.option?.description, translationService.getLanguage())"></div>
                            
                            @if(itemOption.price >= 0) {
                              <div class="option-price" [ngClass]="{'poppinsNormalFont': homersLayout}">
                                <!--might need this instead: "itemOption.option.price"-->
                                +{{itemOption.price * itemOption.quantity | currency}}
                              </div>
                            }
                          </div>
                          
                          @if(itemOptionsCat.isMultiple) {
                            <div class="option-detail-Quantity">
                              <div class="OptionQuantitySelectionContainer">
                                <button class="OptionQuantityBtn" (click)="changeOptionQuantity(itemOption, -1, itemOptionsCat); $event.stopPropagation()">
                                  {{ '-' }}
                                </button>
                                <div class="OptionQuantityCounter">
                                  <!-- Will have to change it later -->
                                  <!--{{ currentItemOptionQuantity(itemOption) }}-->
                                  {{ itemOption.option.quantity || 0 }}
                                </div>
                                <button class="OptionQuantityBtn" (click)="changeOptionQuantity(itemOption, 1, itemOptionsCat); $event.stopPropagation()">
                                  {{ '+' }}
                                </button>
                              </div>
                            </div>
                          }
                          
                          
                        </div>
                        
                      </div>
                    </div>
                  }
                </div>
                

                <!--
                @if(optionGroupIndex == oi) {
                  <div class="optionsubmit-container">
                    @if(this.selectedSubItem.itemOptionCategories.length == oi + 1) {
                      <button class="BuyNowButton" (click)="completeItemOptions()">
                        {{ 'complete item order' }}
                      </button>
                    }@else{
                      <button class="BuyNowButton" (click)="nextOptionGroup(this.selectedSubItem.itemOptionCategories, oi)">
                        {{ 'next options' }}
                      </button>
                    }
                  </div>
                }
                -->

                

                <!--
                  <div class="Item-total-Box">
                    <div class="Item-number-Container">
                      <p>{{total | currency}}</p>
                    </div>
                    @if (item.item.itemOptionCategories[optionIndex].isMultiple == false) {
                      <button class="Item-number-Next btn_disabled">{{ (options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate}}: {{!back ? getOptionsQty() : backSelectedCount()}} / 1</button>
                    }
                    @if (item.item.itemOptionCategories[optionIndex].isMultipleUnlimited == false && item.item.itemOptionCategories[optionIndex].isMultiple) {
                      <button class="Item-number-Next btn_disabled">{{ (options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate }}: {{!back ? getOptionsQty() : backSelectedCount()}} / {{ item.item.itemOptionCategories[optionIndex].multipleLimit != null ? item.item.itemOptionCategories[optionIndex].multipleLimit : item.item.itemOptionCategories[optionIndex].options.length }}</button>
                    }
                    @if (item.item.itemOptionCategories[optionIndex].isMultiple && item.item.itemOptionCategories[optionIndex].isMultipleUnlimited) {
                      <button class="Item-number-Next btn_disabled">{{ 'Choice.SelectUnlimited' | translate }}</button>
                    }
                    @if (!disabledNextBtn()) {
                      <button (click)="optionSelected(null, item.item.itemOptionCategories[optionIndex], true);" class="Item-number-Next NextResize">{{ 'General.Next' | translate }}</button>
                    }
                  </div>
                -->
                
                
                
              </div>
            }
            
          }
        </div>
      }
    </div>
  }

  @if(seeOptions) {
    <div class="optionsubmit-container">
      <div class="total-container">
        <div class="Item-total-Box" [ngClass]="{'disable-Item-total-Box': disableAddOption()}" >

          @if(this.selectedSubItem.itemOptionCategories.length == optionGroupIndex + 1) {
            <!--
            @if (this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultiple == false) {
              <button class="Item-number-Next" [ngClass]="{'poppinsNormalFont': homersLayout}">{{(this.selectedSubItem.itemOptionCategories[optionGroupIndex]?.options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate}}: {{getOptionsQty(this.selectedSubItem.itemOptionCategories[optionGroupIndex])}} / 1</button>
            }

            @if (this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultipleUnlimited == false && this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultiple) {
              <button class="Item-number-Next" [ngClass]="{'poppinsNormalFont': homersLayout}">{{(this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate }}:  {{getOptionsQty(this.selectedSubItem.itemOptionCategories[optionGroupIndex])}} / {{ this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit != null ? this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit : this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length}}</button>
            }

            @if (this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultiple && this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultipleUnlimited) {
              <button class="Item-number-Next" [ngClass]="{'poppinsNormalFont': homersLayout}">{{ 'Choice.SelectUnlimited' | translate }}</button>
            }
            -->

            <!--<button class="Item-number-Next btn_disabled" (click)="completeItemOptions()">{{'complete item order'}}</button>-->
            <button class="Item-number-Next" 
              [ngClass]="{'poppinsNormalFont': homersLayout, 'btn_disabled': !confirmSelection(this.selectedSubItem.itemOptionCategories[optionGroupIndex], optionGroupIndex)}" 
              [disabled]="disableAddOption()"
              (click)="nextOptionGroup(this.selectedSubItem.itemOptionCategories[optionGroupIndex], optionGroupIndex, true)">
                {{getOptionsQty(this.selectedSubItem.itemOptionCategories[optionGroupIndex])}} / {{ this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit != null ? this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit : this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length}} {{'AllinoneMenu.CompleteOrder' | translate}} 
            </button>
            
          } @else {
            <!--
            @if (true) {
              <button class="Item-number-Next" (click)="nextOptionGroup(itemOptionsCat, oi)">{{'next options'}}</button>
            }
            -->

            <!--
            @if (this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultiple == false) {
              <button class="Item-number-Next" [ngClass]="{'poppinsNormalFont': homersLayout}">{{(this.selectedSubItem.itemOptionCategories[optionGroupIndex]?.options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate}}: {{getOptionsQty(this.selectedSubItem.itemOptionCategories[optionGroupIndex])}} / 1</button>
            }

            @if (this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultipleUnlimited == false && this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultiple) {
              <button class="Item-number-Next" [ngClass]="{'poppinsNormalFont': homersLayout}">{{(this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate }}: {{getOptionsQty(this.selectedSubItem.itemOptionCategories[optionGroupIndex])}} / {{ this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit != null ? this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit : this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length}}</button>
            }

            @if (this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultiple && this.selectedSubItem.itemOptionCategories[optionGroupIndex].isMultipleUnlimited) {
              <button class="Item-number-Next" [ngClass]="{'poppinsNormalFont': homersLayout}">{{ 'Choice.SelectUnlimited' | translate }}</button>
            }
            -->

            <!--<button class="Item-number-Next btn_disabled" (click)="nextOptionGroup(itemOptionsCat, oi)">{{ 'General.Next' | translate }}</button>-->
            <button class="Item-number-Next" 
              [ngClass]="{'poppinsNormalFont': homersLayout, 'btn_disabled': !confirmSelection(this.selectedSubItem.itemOptionCategories[optionGroupIndex], optionGroupIndex)}" 
              (click)="nextOptionGroup(this.selectedSubItem.itemOptionCategories[optionGroupIndex], optionGroupIndex, false)">
                {{getOptionsQty(this.selectedSubItem.itemOptionCategories[optionGroupIndex])}} / {{ this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit != null ? this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit : this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length}} {{ 'General.Next' | translate }} 
            </button> 
            
          }

        </div>
      </div>
    </div>
  }
  
</ion-content>

@if (newOrder) {
  <div  class="modal-new-cart">
    <div class="container-warning">
      <div class="new-order">{{'Confirmation.NewOrder' | translate}}</div>
      <p class="para">{{'Confirmation.Warning' | translate}}</p>
      <div class="buttons">
        <button (click)="emptyCart()" class="btns"  style="margin-right: 10px;">{{'General.Yes' | translate}}</button>
        <button class="btns" id="no">{{'General.No' | translate}}</button>
      </div>
    </div>
  </div>
}
